import './ServiceTypes.css';
import eventImage from '../../assets/eventos.avif';

const ServiceTypes = () => {
  const services = [
    {
      title: "Eventos Corporativos",
      description: "Eleve o nível das suas palestras, apresentações e eventos corporativos com painéis de LED que garantem alta visibilidade e profissionalismo. Impressione seus convidados e transmita sua mensagem com impacto."
    },
    {
      title: "Shows e Concertos",
      description: "Crie uma experiência imersiva e inesquecível para o seu público com nossos painéis de LED que amplificam o impacto visual de shows e concertos. Garanta uma performance incrível e uma atmosfera vibrante."
    },
    {
      title: "Festas e Eventos Sociais",
      description: "Personalize sua festa com painéis de LED que criam uma atmosfera única e personalizada. Dê vida à sua decoração, projete mensagens especiais e crie um ambiente vibrante e inesquecível."
    }
  ];

  return (
    <section className="service-types" id="service-types">
      <h2 data-aos="fade-up">Soluções para Eventos Corporativos, Shows e Festas</h2>
      <div className="service-types-container">
        <div className="service-image-container" data-aos="fade-right">
          <img src={eventImage} alt="Eventos com painéis de LED" />
        </div>
        <div className="service-descriptions">
          {services.map((service, index) => (
            <div key={index} className="service-card" data-aos="fade-left" data-aos-delay={index * 100}>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceTypes; 
